import { render, staticRenderFns } from "./searchSuggestArticle.vue?vue&type=template&id=135e0784&scoped=true&"
import script from "./searchSuggestArticle.vue?vue&type=script&lang=js&"
export * from "./searchSuggestArticle.vue?vue&type=script&lang=js&"
import style0 from "./searchSuggestArticle.vue?vue&type=style&index=0&id=135e0784&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135e0784",
  null
  
)

export default component.exports